// src/components/news/NewsModalViewer.jsx
import { useEffect, useState } from "react";
import Modal from "../modal/Modal";
import { BASE_URL } from "../../config";
import "./news.css";
import { useTranslation } from "../../shared/LanguageContext";

export default function NewsModalViewer({ open, onClose, item }) {
    const [idx, setIdx] = useState(0);
    const { language } = useTranslation();

    useEffect(() => {
        if (!open) {
            setIdx(0);
        }
    }, [open]);

    if (!item) return null;

    const videoUrl = item.videoUrl ? (item.videoUrl.startsWith('http') ? item.videoUrl : `${BASE_URL}${item.videoUrl}`) : null;
    const imageUrls = (item.images || []).map(u => (u.startsWith('http') ? u : `${BASE_URL}${u}`));
    const hasImages = imageUrls.length > 0;

    const next = () => setIdx((i) => (i + 1) % (imageUrls.length || 1));
    const prev = () => setIdx((i) => (i - 1 + (imageUrls.length || 1)) % (imageUrls.length || 1));

    const currentTitle = item[`title_${language}`] || item.title;
    const currentLabel = item[`label_${language}`] || item.label;
    const currentHtml = item[`html_${language}`] || item.html || "";

    return (
        <Modal open={open} onClose={onClose} width={980}>
            <div className="news-modal">
                <div className="news-modal-gallery">
                    {/* Видео */}
                    {videoUrl && (
                        <div className="news-modal-frame">
                            <video
                                src={videoUrl}
                                controls
                                playsInline
                                preload="metadata"
                                style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                            />
                        </div>
                    )}

                    {/* Галерея изображений */}
                    {hasImages && (
                        <>
                            <div className="news-modal-frame">
                                <img src={imageUrls[idx]} alt="" />
                                {imageUrls.length > 1 && (
                                    <>
                                        <button className="news-modal-nav left" onClick={prev} aria-label="prev">‹</button>
                                        <button className="news-modal-nav right" onClick={next} aria-label="next">›</button>
                                    </>
                                )}
                            </div>
                            {imageUrls.length > 1 && (
                                <div className="news-modal-thumbs">
                                    {imageUrls.map((src, i) => (
                                        <button
                                            key={i}
                                            className={"news-thumb" + (i === idx ? " active" : "")}
                                            onClick={() => setIdx(i)}
                                            aria-label={"thumb " + (i + 1)}
                                        >
                                            <img src={src} alt="" />
                                        </button>
                                    ))}
                                </div>
                            )}
                        </>
                    )}
                </div>

                <div className="news-modal-content">
                    {currentLabel && <span className="news-feature-label">{currentLabel}</span>}
                    <h3 className="news-modal-title">{currentTitle}</h3>
                    <div className="news-modal-html" dangerouslySetInnerHTML={{ __html: currentHtml }} />
                </div>
            </div>
        </Modal>
    );
}
